import { AdminPanelOption } from "../../models/admin";

export const basicUserMenuOptions = [
    { key: "Collections", text: "Collections", value: true },
    { key: "Settings", text: "Settings", value: false },
]

export const basicUserPanelOptionToggle = () => {
    const options: AdminPanelOption[] = [];
    for (const iterator of basicUserMenuOptions) {
        const opt: AdminPanelOption = {
            optionName: iterator.text,
            toggle: iterator.value,
            key: iterator.key
        }
        options.push(opt)
    }
    return options;
};


export const basicUserCollections = "Collections";
export const basicUserSettings = "Settings";